import _parseInt from 'lodash/parseInt';
import APPCONFIG from '../../../constants/Config';
import {
  REINIT_STATE,
  CPM_LIST_SLUGS,
  CPM_CREATE_SLUG,
  CPM_DELETE_SLUG,
  CPM_UPDATE_SLUG,
  CPM_GET_SLUG_BY_DOMAIN,
} from '../../../constants/ActionTypes';
// Models
/* eslint-disable import/named */
import { deserialize } from '../../../models/cpm/slug';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.cpmSlug;
const cpmSlug = (state = initialSettings, action) => {
  let key;
  switch (action.type) {
    // REINIT STATE
    case REINIT_STATE:
      key = null;
      switch (action.target) {
        case 'updateSlug':
          key = 'update';
          break;
        case 'addSlug':
          key = 'add';
          break;
        default:
          break;
      }
      if (key) {
        return {
          ...state,
          [key]: {
            ...initialSettings[key],
          },
        };
      }
      return state;
    // CPM_LIST_SLUGS
    case CPM_LIST_SLUGS:
      return {
        ...state,
        list: {
          ...state.list,
          loading: true,
          error: null,
          elements: {
            ...state.list.elements,
            data: null,
          },
        },
      };
    case `${CPM_LIST_SLUGS}_ERROR`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_LIST_SLUGS}_SUCCESS`:
      return {
        ...state,
        list: {
          ...state.list,
          loading: false,
          elements: {
            ...state.list.elements,
            data: deserialize(action.data.listSlugs.entries),
            pageNumber: _parseInt(action.data.listSlugs.pageNumber),
            pageSize: _parseInt(action.data.listSlugs.pageSize),
            totalEntries: _parseInt(action.data.listSlugs.totalEntries),
            totalPages: _parseInt(action.data.listSlugs.totalPages),
          },
        },
      };
    // CPM_CREATE_SLUG
    case CPM_CREATE_SLUG:
      return {
        ...state,
        add: {
          ...state.add,
          added: false,
          error: null,
        },
      };
    case `${CPM_CREATE_SLUG}_ERROR`:
      return {
        ...state,
        add: {
          ...state.add,
          error: action.error,
        },
      };
    case `${CPM_CREATE_SLUG}_SUCCESS`:
      return {
        ...state,
        add: {
          ...state.add,
          added: true,
        },
      };
    // CPM_DELETE_SLUG
    case CPM_DELETE_SLUG:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: false,
          error: null,
        },
      };
    case `${CPM_DELETE_SLUG}_ERROR`:
      return {
        ...state,
        delete: {
          ...state.delete,
          error: action.error,
        },
      };
    case `${CPM_DELETE_SLUG}_SUCCESS`:
      return {
        ...state,
        delete: {
          ...state.delete,
          deleted: true,
        },
      };
    // CPM_UPDATE_SLUG
    case CPM_UPDATE_SLUG:
      return {
        ...state,
        update: {
          ...state.update,
          updated: false,
          error: null,
        },
      };
    case `${CPM_UPDATE_SLUG}_ERROR`:
      return {
        ...state,
        update: {
          ...state.update,
          error: action.error,
        },
      };
    case `${CPM_UPDATE_SLUG}_SUCCESS`:
      return {
        ...state,
        update: {
          ...state.update,
          updated: true,
        },
      };
    // CPM_GET_SLUG_BY_DOMAIN
    case CPM_GET_SLUG_BY_DOMAIN:
      return {
        ...state,
        current: {
          ...state.current,
          loading: true,
          error: null,
        },
      };
    case `${CPM_GET_SLUG_BY_DOMAIN}_ERROR`:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: action.error,
        },
      };
    case `${CPM_GET_SLUG_BY_DOMAIN}_SUCCESS`:
      return {
        ...state,
        current: {
          ...state.current,
          loading: false,
          error: null,
          result: deserialize(action.data.getSlugByDomain),
        },
      };
    default:
      return state;
  }
};

export default cpmSlug;



// WEBPACK FOOTER //
// ./reducers/cpm/workspace/slug.js